// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file temporal/ontology/project_discovery.proto (package gx.temporal.ontology, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../services/database/models/public_pb.js";

/**
 * Describes the file temporal/ontology/project_discovery.proto.
 */
export const file_temporal_ontology_project_discovery = /*@__PURE__*/
  fileDesc("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", [file_services_database_models_public]);

/**
 * Describes the message gx.temporal.ontology.SourceArtifactSet.
 * Use `create(SourceArtifactSetSchema)` to create a new message.
 */
export const SourceArtifactSetSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 0);

/**
 * Describes the message gx.temporal.ontology.OntologyProjectDiscoveryWorkflowInput.
 * Use `create(OntologyProjectDiscoveryWorkflowInputSchema)` to create a new message.
 */
export const OntologyProjectDiscoveryWorkflowInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 1);

/**
 * Describes the message gx.temporal.ontology.OntologyProjectDiscoveryWorkflowOutput.
 * Use `create(OntologyProjectDiscoveryWorkflowOutputSchema)` to create a new message.
 */
export const OntologyProjectDiscoveryWorkflowOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 2);

/**
 * Describes the message gx.temporal.ontology.ProjectOntologyActivityInput.
 * Use `create(ProjectOntologyActivityInputSchema)` to create a new message.
 */
export const ProjectOntologyActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 3);

/**
 * Describes the message gx.temporal.ontology.ProjectOntologyActivityOutput.
 * Use `create(ProjectOntologyActivityOutputSchema)` to create a new message.
 */
export const ProjectOntologyActivityOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 4);

/**
 * Describes the message gx.temporal.ontology.ResolveEntitiesActivityInput.
 * Use `create(ResolveEntitiesActivityInputSchema)` to create a new message.
 */
export const ResolveEntitiesActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 5);

/**
 * Describes the message gx.temporal.ontology.ResolveEntitiesActivityOutput.
 * Use `create(ResolveEntitiesActivityOutputSchema)` to create a new message.
 */
export const ResolveEntitiesActivityOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 6);

/**
 * Describes the message gx.temporal.ontology.FinalizeProjectActivityInput.
 * Use `create(FinalizeProjectActivityInputSchema)` to create a new message.
 */
export const FinalizeProjectActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 7);

/**
 * Describes the message gx.temporal.ontology.FinalizeProjectActivityOutput.
 * Use `create(FinalizeProjectActivityOutputSchema)` to create a new message.
 */
export const FinalizeProjectActivityOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_discovery, 8);

